<div>
<ng-container *ngIf="items$ |async as items">
  <div *ngFor="let item of items , let i = index">
<div class="alert alert-dismissible bg-light-primary d-flex flex-column flex-sm-row">
  <!--begin::Icon-->
<!--  <i class="ki-duotone ki-notification-bing fs-2hx text-primary me-4 mb-5 mb-sm-0"><span class="path1"></span><span class="path2"></span><span class="path3"></span></i>-->
  <!--end::Icon-->

  <!--begin::Wrapper-->
  <div class="d-flex flex-column pe-0 pe-sm-10 w-100">
    <!--begin::Title-->
    <h4 class="fw-semibold">{{item?.title}}</h4>
    <!--end::Title-->
    <!--begin::Content-->
    <output class="banner-content" [innerHtml]="santizeHTML(item?.body)"></output>
    <!-- <output class="banner-content" >{{item?.body}}</output> -->
    <!--end::Content-->
  </div>
  <!--end::Wrapper-->

  <!--begin::Close-->
  <button (click)="close(item.id , i)" type="button" class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon btn-outline-white ms-sm-auto" data-bs-dismiss="alert">
    <i class=" fa-solid fa-x fa-2xl text-primary"><span class="path1"></span><span class="path2"></span></i>
  </button>
  <!--end::Close-->
</div>
  </div>
</ng-container>
</div>
<!--begin::Alert-->
<!--end::Alert-->
